module.exports = __webpack_public_path__ + "static/img/icon-team-folder.546a9d92.png";